<template>
  <!-- prettier-ignore -->
  <svg
    class="app-notification-icon"
    :class="`app-notification-icon--${variant}`"
    viewBox="0 0 28 28"
  >
    <g v-if="variant === 'info' || variant === 'unique'">
      <circle class="app-notification-icon__bg" cx="14" cy="14" r="12.8" fill="currentColor" />
      <path d="M15.4 20v.3a2 2 0 0 1-1.6.7q-1 0-1.6-.5-.5-.6-.5-1.4l.3-2.4.7-3.6q0-.5-.4-.5H12a.2.2 0 0 1 0-.4h.7l2.5-.1q.2 0 .3.2l-1.4 7.5q0 .7.6.5l.2-.2q.2-.2.4 0M13.5 9.8q-.4-.5-.4-1.1 0-.8.4-1.2.5-.5 1.2-.5t1.1.5.5 1.2-.5 1.1-1.1.5-1.2-.5" fill="currentColor" />
    </g>

    <g v-if="variant === 'success'">
      <circle class="app-notification-icon__bg" cx="14" cy="14" r="12.8" fill="currentColor" />
      <path d="m21 9.9-7.7 8.4-5.1-5.1" fill="none" stroke="currentColor"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>

    <g v-if="variant === 'warning'">
      <path class="app-notification-icon__bg" d="m16.4 4.8 8.9 15.7c1 1.8-.3 4-2.4 4H5.1a2.7 2.7 0 0 1-2.4-4l9-15.7c1-1.8 3.6-1.8 4.7 0" fill="currentColor"></path>
      <path d="M14 15.3v-4.4" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M14 20.4q-1.2-.1-1.3-1.3a1.3 1.3 0 1 1 1.3 1.3" fill="currentColor"></path>
    </g>

    <g v-if="variant === 'error'">
      <circle class="app-notification-icon__bg" cx="14" cy="14" r="12.8" fill="currentColor" />
      <path d="M17.7 18.8q.6.4 1.1 0 .4-.6 0-1l-.5.5zm-7.4-9.6a1 1 0 0 0-1 0q-.5.6 0 1l.5-.5zm-.5.5-.5.6 8.4 8.5.6-.5.5-.6-8.5-8.5z" fill="currentColor" />
      <path d="M9.2 17.7q-.5.6 0 1.1.6.4 1 0l-.5-.5zm9.5-7.4q.4-.6 0-1.1a1 1 0 0 0-1 0l.5.5zm-.5-.6-.5-.5-8.5 8.5.5.6.6.5 8.4-8.5z" fill="currentColor" />
    </g>
  </svg>
</template>

<script setup lang="ts">
import type { NotificationVariant } from '@/services/notification.app'

defineProps<{
  variant: NotificationVariant
}>()
</script>

<style lang="scss" scoped>
.app-notification-icon {
  color: var(--notificationIconColor);

  &__bg {
    color: var(--notificationIconBgColor);
  }
}

.app-notification-icon--info,
.app-notification-icon--unique {
  --notificationIconColor: #{$c-blue-4};
  --notificationIconBgColor: #{rgba($c-blue-2, 0.12)};

  .night-mode & {
    --notificationIconBgColor: #{rgba($c-blue-2, 0.3)};
  }
}

.app-notification-icon--success {
  --notificationIconColor: #{$c-green-2};
  --notificationIconBgColor: #{rgba($c-green-2, 0.2)};

  .night-mode & {
    --notificationIconBgColor: #{rgba($c-green-2, 0.3)};
  }
}

.app-notification-icon--warning {
  --notificationIconColor: #{$c-orange};
  --notificationIconBgColor: #{rgba($c-orange, 0.2)};
}

.app-notification-icon--error {
  --notificationIconColor: #{$c-red-6};
  --notificationIconBgColor: #{rgba($c-red-6, 0.2)};
}
</style>
